import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';

import {
  Add_New_Commission,
  Delete_Selected_Commission_Type,
  Get_All_Leads_Commissions_For_Selected_Lead,
  Get_Error,
  Get_One_Commission_Type,
  Update_Selected_Commisssion_Type,
} from '../Types';

// Add Commission Data
export const Add_Commission_Data_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Commission`, body);

    dispatch({
      type: Add_New_Commission,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Get All Commission Data
export const Get_Commission_Data_For_Selected_Lead_Action = (leadid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Commission?lead=${leadid}`);

    dispatch({
      type: Get_All_Leads_Commissions_For_Selected_Lead,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// / Get one Commission Data
export const Get_One_Commission_Data_Action = (commissionid) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Commission/${commissionid}`);

    dispatch({
      type: Get_One_Commission_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// / Get one Commission Data
export const Update_One_Commission_Data_Action = (commissionid, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Commission/${commissionid}`, body);

    dispatch({
      type: Update_Selected_Commisssion_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// / Delete Selected Commission Data
export const Delete_One_Commission_Data_Action = (commissionid) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Commission/${commissionid}`);

    dispatch({
      type: Delete_Selected_Commission_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
